import React from 'react';

function QuestionInput(props: {
    placeholder: string;
    value: string;
    setValue: (v: string) => void;
    onChange: (e: React.ChangeEvent) => void;
}): JSX.Element {
    const { placeholder, value, onChange } = props;
    return <input type="text" id="textField_text" value={value} onChange={onChange} placeholder={placeholder} />;
}

export default QuestionInput;
